import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import AvatarGroupSvg from 'assets/svgr-icons/Avatar_Group.svg'

const PUBLIC_AVATARS_BG =
  'https://s3.eu-central-1.wasabisys.com/videostatic.rfstat.com/v-editor/avatars/public-avatar-bg.png'

export const PublicAvatarsCard = styled.button<{ $isActive?: boolean }>`
  position: relative;
  flex: 1;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  outline: 2px solid
    ${({ $isActive }) => ($isActive ? COLORS.primaryDark : 'transparent')};
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  background-image: url(${PUBLIC_AVATARS_BG});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  transition: outline-color 0.15s ease;

  /* darkening overlay so the icon and label stay readable over the photos */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(37, 46, 72, 0.8);
    transition: background-color 0.15s ease;
  }

  /* &:hover::before {
    background-color: rgba(37, 46, 72, 0.4);
  } */

  &:hover,
  &:active,
  &:focus-visible {
    outline-color: ${COLORS.primaryDark};
  }
`

export const Content = styled.span`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
`

export const GroupIcon = styled(AvatarGroupSvg)`
  width: 28px;
  height: 28px;
  color: ${COLORS.white};
`
